import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Image from '../../../components/image'
import WidgetBox, { WidgetTitle } from '../../../components/shared/widget-box'
import { InstagramWrap, InstagramItem } from './instagram.stc'


const Instagram = ({ widgetStyle }) => {
	const galleryData = useStaticQuery(graphql`
		query instagramWidgetQuery {
			allGalleryJson(limit: 6) {
				nodes {
					image {
						src {
							childImageSharp {
								gatsbyImageData(width: 300, height: 300, placeholder: TRACED_SVG, quality: 100)
							}
						}
						alt
					}
				}
			}
		}	  
	`);

	const photos = galleryData.allGalleryJson.nodes
	return (
		<WidgetBox {...widgetStyle}>
			<WidgetTitle>Gallery</WidgetTitle>
			<InstagramWrap>
				{photos && photos.map((photo, i) => (
					<InstagramItem key={`Gallery-${i}`}>
						{photo?.image?.src && (
							<Image src={photo.image.src} alt={photo.image?.alt || "Gallery"} />
						)}
						{/* {photo.node.preview && <a href={photo.node.preview} target="_blank" rel="noopener noreferrer">Preview Link</a>} */}
					</InstagramItem>
				))}
			</InstagramWrap>
		</WidgetBox>
	)
}

Instagram.defaultProps = {
	widgetStyle: {
		skin: 'primary'
	}
}

export default Instagram
